// @codekit-prepend quiet "modifyOrder/index.js";
// @codekit-prepend quiet "utilities.min.js";
// @codekit-prepend quiet "owlCalendar.min.js";
// @codekit-prepend quiet "xolaOrder.min.js";
// @codekit-prepend quiet "loaders.min.js";
// @codekit-prepend quiet "retrieveOrder/index.min.js";
// @codekit-prepend quiet "cancelAndRefund/index.min.js";
// @codekit-prepend quiet "experience.min.js";

const page = 'self-service';

function getTravelerApiKey() {
    if (window.location.hash) {
        const tApiKey = window.location.hash.substring(1);
        sessionStorage.setItem("tApiKey", tApiKey);
        console.log(tApiKey);
        return tApiKey;
    } else {
        console.log("no apikey found");
    }
}

function getXolaApiUrl() {

    function handleErrors(response) {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response;
    }

    return fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
        },
        body: new URLSearchParams({
            action: 'get_xola_api_url'
        }),

    }).then(handleErrors)
        .then(function (response) {
            return response.json();
        }).catch(function (error) {
            console.log("ERROR")
            return error;
        });
}


jQuery('a.btn.cancel').on('click', function (e) {
    e.preventDefault();
    modalCancel();
});

jQuery('a.btn.change').on('click', function (e) {
    e.preventDefault();
    // modalChangeReservationDate();
    initializeCalendar();
    jQuery('.calendar').css('display', 'block');
    jQuery('a.btn.change').css('display', 'none');
});


const modalCancel = () => {
    const modal = new tingle.modal({
        footer: true,
        stickyFooter: false,
        closeMethods: ['overlay', 'button', 'escape'],
        closeLabel: "Close",
        cssClass: ['custom-class-1', 'custom-class-2'],
        onOpen: function () {

            // const btnAbortCancellation = jQuery("#cancel__modal_close").html();
            const btnAbortCancellation = "DO NOT CANCEL";
            modal.addFooterBtn(btnAbortCancellation, 'tingle-btn btn-1', function () {
                modal.close();
            })

            // const btnConfirmCancel = jQuery("#cancel__modal_confirm").html();
            const btnConfirmCancel = "CONFIRM CANCEL";
            modal.addFooterBtn(btnConfirmCancel, 'tingle-btn btn-2', function () {

                const loader = new Loaders();
                const modalText = loader.processing("CANCELLING RESERVATION");
                jQuery(".tingle-modal-box__footer").hide();
                modal.setContent(modalText);
                cancelAndRefund(XolaOrder.getOrderId()).then(r => {
                    console.log(r.success);
                    if (r.success === true) {
                        modal.setContent("Your order has been successfully cancelled.");
                    } else {
                        modal.setContent("There was an error processing your request.");
                    }
                    jQuery(".tingle-modal-box__footer .tingle-btn.btn-1,.tingle-modal-box__footer .tingle-btn.btn-2").hide();
                    jQuery(".tingle-modal-box__footer").show();
                    modal.addFooterBtn('Ok', 'tingle-btn', function () {
                        window.location.assign('/manage-reservation/?login=' + XolaOrder.getOrderId() + '&token=#' + XolaOrder.getApiToken());
                    });

                });

                /*
                xolaCancelAndRefundOrder(XolaOrder.getOrderId()).then(r => {
                    console.log(r.success);
                    if (r.success === true) {
                        modal.setContent("Your order has been successfully cancelled.");
                    } else {
                        modal.setContent("There was an error processing your request.");
                    }
                    jQuery(".tingle-modal-box__footer .tingle-btn.btn-1,.tingle-modal-box__footer .tingle-btn.btn-2").hide();
                    jQuery(".tingle-modal-box__footer").show();
                    modal.addFooterBtn('Ok', 'tingle-btn', function () {
                        window.location.assign('/manage-reservation/?login=' + XolaOrder.getOrderId() + '&token=#' + XolaOrder.getApiToken());
                    });

                });*/

            });

        },

        onClose: function () {
            modal.destroy();
        },
        beforeClose: function () {
            // here's goes some logic
            // e.g. save content before closing the modalReleaseHold
            return true; // close the modalReleaseHold
            return false; // nothing happens
        }
    });
    let modalText = jQuery("#cancel__source").html();
    const orderAmt = jQuery("#baseAmount").data("base-amount");
    modalText = modalText + "<br>Refund Amount: $" + orderAmt;
    // jQuery("div#cancel__source").prepend(modalText)
    // var modalText = acf.get('waiver');
    modal.setContent(modalText);
    modal.open();
};

const modalChangeReservationDate = () => {
    const modal = new tingle.modal({
        footer: true,
        stickyFooter: false,
        closeMethods: ['overlay', 'button', 'escape'],
        closeLabel: "Close",
        cssClass: ['custom-class-1', 'custom-class-2'],
        onOpen: function () {


            const btnAbortCancellation = "Close";
            modal.addFooterBtn(btnAbortCancellation, 'tingle-btn', function () {
                modal.close();
            })

            // const btnConfirmCancel = jQuery("#cancel__modal_confirm").html();
            // modal.addFooterBtn(btnConfirmCancel, 'tingle-btn', function () {
            //   modal.close();
            // });

        },

        onClose: function () {
            modal.destroy();
        },
        beforeClose: function () {
            // here's goes some logic
            // e.g. save content before closing the modalReleaseHold
            return true; // close the modalReleaseHold
            return false; // nothing happens
        }
    });
    let modalText = "<h2>Change Reservation Date</h2><div style='border: 1px solid #ccc; height: 400px;'></div>"
    // const orderAmt = jQuery(".btn.cancel").data("payment-amount");
    // modalText = modalText + "<br>Refund Amount: $" + orderAmt.toFixed(2);
    // jQuery("div#cancel__source").prepend(modalText)
    // var modalText = acf.get('waiver');
    modal.setContent(modalText);
    modal.open();
};

function getXolaOrder() {
    function handleErrors(response) {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response;
    }

    return fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
        },
        body: new URLSearchParams({
            action: 'run_xola_get_order_from_selfservice',
            token: getTravelerApiKey(),
            oid: getUrlVars()["login"]
        }),
    }).then(handleErrors)
        .then(function (response) {
            // console.log(response);
            return response.json();
        }).catch(function (error) {
            console.log("ERROR")
            return error;
        });
}


window.onload = function () {
    const loginId = getUrlVars()["login"];
    if (loginId) {
        initializeAuth();
    } else {
        if (XolaOrder.getOrderId() && XolaOrder.getApiToken()) {
            initializeSelfService();
        }
    }
}

function initializeAuth() {
    console.log("commence authorization");
    console.log(getUrlVars()["login"]);
    getXolaOrder().then(r => {
        console.log(r);
        if (r.data) {
            console.log("authorization succeeded!");
            const xolaOrder = new XolaOrder();
            xolaOrder.saveOrderToBrowser(r.data);
            OwlCarousel.setApplicationName("selfservice");
        } else {
            console.log("AUTHORIZATION DENIED");
        }
        window.location.assign("/manage-reservation/");
    })
}


class SelfserviceCalendar extends OwlCarousel {
    constructor(selector) {
        super(selector);
    }

    initializeNewCarousel() {
        this.caro.owlCarousel({
            loop: false,
            margin: 20,
            nav: false,
            dots: false,
            mouseDrag: false,
            responsive: {
                0: {
                    items: 1,
                },
            },
            // onRefreshed: this.triggerEventsOnCalendarRedraw()
        });
        this.addClicks(this.caro);
        this.caro.on('changed.owl.carousel', function (event) {
            SelfserviceCalendar.triggerEventOnCarouselChange();
        });
        this.triggerEventsOnCalendarRedraw();
        // super.initializeNewCarousel();
    }

    static triggerEventOnCarouselChange() {
        super.triggerEventOnCarouselChange();
        console.log("selfservice.js triggerEventOnCarouselChange");
        // ticketingInterfaceUnlock();
    }

    triggerEventsOnCalendarRedraw() {
        super.triggerEventsOnCalendarRedraw();
        console.log("self-service calendar redraw");
        if (sessionStorage.getItem("calendarLoaded") === "0") {
            sessionStorage.setItem("calendarLoaded", "1");
            // setStateOnPageLoad();
        }
        return null
    }

}

function initializeCalendar() {
    const oc = new SelfserviceCalendar(jQuery('.calendar .owl-carousel'));
    oc.initializeNewCarousel();
}

async function initializeSelfService() {
    console.log("initalizeSelfService");
    const sideCart = new SideCart();
    sideCart.showCart();
    sideCart.addClassToCart("responsive");
    sideCart.addClassToCart("selfservice");
    let items = JSON.parse(sessionStorage.getItem("items"));
    console.log(items);
    const experiences = new Experience();
    await experiences.init(function () {
        // if we need to call a function on the experience class we would do it here
        // experiences.testFunction();
        sideCart.updateCart(items, 'Order Itinerary', false);
    });

    // getOrder().then(r => {
    //   console.log(r['items']);
    //   const sideCart = new SideCart();
    //   sideCart.updateCart(r['items'], 'Order Itinerary', false);
    //   sideCart.showCart();
    // });
    // getTravelerApiKey();
    // getXolaApiUrl().then(r => {
    //   console.log(r.data);
    //   sessionStorage.setItem("apiUrl", r.data);
    // });
}
